import React, { Component } from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import "./RichTextCss.css";
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';

const EditorWrapper = styled.div`
  .public-DraftEditorPlaceholder-root {
    color: rgba(0, 0, 0, 0.4);
    position: absolute;
    pointer-events: none;
  }
`;

function convertToPlainText(editorContent) {
  const blocks = convertToRaw(editorContent).blocks;
  const plainText = blocks.map(block => block.text).join('\n');
  return plainText;
}

export default class RichText extends Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      const contentState = ContentState.createFromText(value);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState });
    }
  }

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });

    const { getContent, name } = this.props;
    const contentState = editorState.getCurrentContent();
    const plainText = convertToPlainText(contentState);
    getContent(plainText, name);
  };

  render() {
    const { placeholder } = this.props;
    return (
      <div>
        <EditorWrapper>
          <Editor
            editorStyle={{ 
              minHeight: 154,
              padding: "8px",
              lineHeight: "normal",
              resize: "vertical",
              overflow: "auto",
              fontSize: "16px",
            }}
            placeholder={placeholder}
            editorState={this.state.editorState}
            toolbarClassName="toolbar"
            wrapperClassName=""
            editorClassName="editor"
            toolbar={false}
            onEditorStateChange={this.onEditorStateChange}
          />
        </EditorWrapper>
      </div>
    );
  }
}
